export var DEVICES_GET_ALL_CONTENT_TYPE = 'application/vnd.getdevices.v1+json';
export var DEVICE_REGISTRATION_STATUS_CONTENT_TYPE = 'application/vnd.deviceregistrationstatus.v1+json';
export var DEVICE_REMOVE_CONTENT_TYPE = 'application/vnd.removedevice.v1+json';
export var DEVICE_UPDATE_CONTENT_TYPE = 'application/vnd.updatedevice.v1+json';
export var DEVICE_ADD_CONTENT_TYPE = 'application/vnd.adddevice.v1+json';
export var START_PREFETCH_CONTENT_TYPE = 'application/vnd.preauth-stream.v1+json';
//# sourceMappingURL=device-manager-constants.js.map